<app-header></app-header>
<div class="image-container">
  <img style="padding: 0; margin: 0;" src="assets/navimage.png" width="100%" alt="Your Image">
  <div class="image-text">
    <p>Contact Us</p>
  </div>
</div>
<div class="bg-white" style="height: 10vh;"></div>
<div class="container-fluid text-white" style="background-color: #0A156F;">
  <div class="row">
    <div class="col-lg-4"></div>
    <div class="col-lg-8 p-4 ps-4 about text-center"></div>
    <div class="col-lg-4 col-md-6 col-sm-12 ps-5 my-2">
      <div class="d-flex my-4 ms-5">
        <div class="round "><mat-icon class="text-center align-items-center"> email</mat-icon></div>
        <div class="d-flex flex-column ps-2">
          <span>Email</span>
          <span>rvsbgs08@gmail.com</span>
        </div>
      </div>

      <div class="d-flex my-5 ms-5">
        <div class="round"><mat-icon class="text-center align-items-center"> phone</mat-icon></div>
        <div class="d-flex flex-column ps-2">
          <span>Phone</span>
          <span>+91-7004321674 / +91-7827370883</span>
          <!-- <span>+91-9431022739</span> -->
        </div>
      </div>

      <div class="d-flex my-5 ms-5">
        <div class="round"><mat-icon class="text-center align-items-center"> place</mat-icon></div>
        <div class="d-flex flex-column ps-2">
          <span>Address</span>
          <span>River Valley School Anand Vihar , Institutional Area, SH-55 , Begusarai -851218</span>
        </div>
      </div>
    </div>

    <div class="col-lg-8 col-md-6 col-sm-12 px-4 my-2">
      <div class="row">
        <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2 mt-2">
          <label for="inputField">Name</label>
          <input type="text" id="inputField" name="inputField" class="white-border">
        </div>


        <div class="mt-2 d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2">
          <label for="inputField">Email</label>
          <input type="text" id="email" name="inputField" class="white-border">
        </div>
      </div>

      <div class="row mt-2">
        <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2 mt-2">
          <label for="inputField">Phone</label>
          <input type="text" id="phone" name="inputField" class="white-border">
        </div>

        <div class="mt-2 d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2">
          <label for="inputField">Subject</label>
          <input type="text" id="subject" name="inputField" class="white-border">
        </div>
      </div>

      <div class="row mt-2">
        <div class="d-flex flex-column col-lg-12 col-md-6 col-sm-12 px-2">
          <label for="inputField">Description</label>
          <textarea id="messageField" name="messageField" class="white-border1" rows="4"></textarea>
        </div>
      </div>

      <div class="mt-4 text-center">
        <button mat-button style="background-color: #F09959;">Send Message</button>
      </div>


    </div>
  </div>
</div>
<app-footer></app-footer>